import React from "react"
import useWindowSize from "../../utility/useWindowSize";
import CCOContainer from "./CCOContainer";
import CCORichText from "./CCORichText/CCORichText";
import CCOComponentWrapper from "./CCOComponentWrapper";
import {getContainerWidth} from "../../utility/componentUtil";

interface Props {
    item: any,
    layoutSettings?: any,
    noTopMargin?: boolean,
}

function renderArticle(props: Props) {
    const containerWidth = getContainerWidth(props.layoutSettings?.contentWidth);
    return <CCOContainer id={props.item.id} width={containerWidth}>
        <CCORichText metadataId={props.item.id} propertyName='properties.detailText' textAsTree={props.item.detailText.textAsTree}
                     docType={'article'}></CCORichText>
    </CCOContainer>
}

function CCOArticle(props: Props) {
    const {greaterThanWindowMedium} = useWindowSize();
    return (
        <CCOComponentWrapper
            noBottomMargin={props.layoutSettings?.noBottomMargin && greaterThanWindowMedium}
            noTopMargin={props.noTopMargin}
        >
            {renderArticle(props)}
        </CCOComponentWrapper>)
}

export default CCOArticle